class BotanicalsCarousel {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.container = wrapper.querySelector('.botanicals-grid-container');
    this.grid = wrapper.querySelector('.botanicals-grid');
    this.prevBtn = wrapper.querySelector('.carousel-nav--prev');
    this.nextBtn = wrapper.querySelector('.carousel-nav--next');
    this.dotsContainer = wrapper.parentElement.querySelector('.carousel-dots');
    this.items = wrapper.querySelectorAll('.botanical-item');
    
    this.currentIndex = 0;
    this.itemWidth = 0;
    this.visibleItems = 1;
    this.maxIndex = 0;
    
    this.init();
  }
  
  init() {
    if (window.innerWidth > 749) return; // Only initialize on mobile
    
    this.calculateDimensions();
    this.createDots();
    this.bindEvents();
    this.updateNavigation();
    
    // Recalculate on resize
    window.addEventListener('resize', this.debounce(this.handleResize.bind(this), 100));
  }
  
  // Debounce function to prevent excessive resize calculations
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  calculateDimensions() {
    if (this.items.length === 0) return;
    
    const containerWidth = this.container.offsetWidth;
    const itemStyle = window.getComputedStyle(this.items[0]);
    this.itemWidth = this.items[0].offsetWidth + parseInt(itemStyle.marginRight);
    this.visibleItems = Math.floor(containerWidth / this.itemWidth);
    this.maxIndex = Math.max(0, this.items.length - this.visibleItems);
  }
  
  createDots() {
    if (!this.dotsContainer || this.items.length <= this.visibleItems) return;
    
    this.dotsContainer.innerHTML = '';
    const totalDots = this.maxIndex + 1;
    
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('button');
      dot.classList.add('carousel-dot');
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => this.goToSlide(i));
      this.dotsContainer.appendChild(dot);
    }
    
    this.updateDots();
  }
  
  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', this.prev.bind(this));
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', this.next.bind(this));
    }
    
    // Touch events for swipe navigation
    let startX = 0;
    let startY = 0;
    let isDragging = false;
    
    this.container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
    });
    
    this.container.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
    });
    
    this.container.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const diffX = startX - endX;
      const diffY = startY - endY;
      
      // Only trigger swipe if horizontal movement is greater than vertical
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        if (diffX > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    });
  }
  
  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateCarousel();
    }
  }
  
  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.updateCarousel();
    }
  }
  
  goToSlide(index) {
    this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
    this.updateCarousel();
  }
  
  updateCarousel() {
    const scrollLeft = this.currentIndex * this.itemWidth;
    this.container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
    
    this.updateNavigation();
    this.updateDots();
  }
  
  updateNavigation() {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
    }
    
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    }
  }
  
  updateDots() {
    const dots = this.dotsContainer?.querySelectorAll('.carousel-dot');
    if (!dots) return;
    
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }
  
  handleResize() {
    if (window.innerWidth > 749) {
      // Desktop - hide carousel elements
      if (this.dotsContainer) this.dotsContainer.style.display = 'none';
      return;
    }
    
    // Mobile - recalculate and show carousel elements
    if (this.dotsContainer) this.dotsContainer.style.display = 'flex';
    this.calculateDimensions();
    this.createDots();
    this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
    this.updateCarousel();
  }
}

// Initialize carousels when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const carouselWrappers = document.querySelectorAll('.botanicals-carousel-wrapper');
  carouselWrappers.forEach(wrapper => {
    new BotanicalsCarousel(wrapper);
  });
});

// Handle Shopify theme editor events
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  // Theme editor is active
  document.addEventListener('shopify:section:load', function(event) {
    const carouselWrappers = event.target.querySelectorAll('.botanicals-carousel-wrapper');
    carouselWrappers.forEach(wrapper => {
      new BotanicalsCarousel(wrapper);
    });
  });
  
  document.addEventListener('shopify:section:reorder', function(event) {
    const carouselWrappers = event.target.querySelectorAll('.botanicals-carousel-wrapper');
    carouselWrappers.forEach(wrapper => {
      new BotanicalsCarousel(wrapper);
    });
  });
} else {
  // Fallback for non-Shopify environments or when theme editor is not active
  window.addEventListener('load', function() {
    const carouselWrappers = document.querySelectorAll('.botanicals-carousel-wrapper');
    carouselWrappers.forEach(wrapper => {
      new BotanicalsCarousel(wrapper);
    });
  });
} 